import { Alert } from "@mui/material";

export default function DemoAlert(): JSX.Element {
    return <Alert severity="info">This is a Demo preview</Alert>
}